// https://sponda-kohteet.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/html/code/show/9z052f73Q86vXPReJObOhQ

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colorClassNames } from 'lib/settings';

const StyledPage = styled.div`
	position: relative;
	box-shadow: 0px 5px 40px -16px rgb(0,0,0);
	transform-origin: 0 0;
	background-color: white;
`;

const PatternContainer = styled.div`
	position: absolute;
	bottom: 0mm;
	right: 0mm;
	width: 150mm;
	height: 150mm;
	z-index: 0;
	overflow: hidden;

	svg {
		height: 150mm;
		width: 150mm;
		position: absolute;
		right: -55mm;
		bottom: -35mm;
		transform: rotate(90deg);
	}
`;

const LogoContainer = styled.div`
	position: absolute;
	bottom: 10mm;
	left: 50%;
	width: auto;
	height: 10mm;
	transform: translateX(-50%);
	z-index: 0;
	overflow: hidden;

	svg {
		height: 100%;
    width: auto;
	}
`;

const MoveInContainer = styled.div`
	position: absolute;
	top: 10mm;
	right: 10mm;
	width: 25mm;
	height: 25mm;
	z-index: 10;
	overflow: hidden;

	svg {
		width: 100%;
		height: 100%;
	}
`;

const Page = props => {
	const { classList, options } = props;
	const bgColor = options['background-color'];
	const bgColorClass = bgColor in colorClassNames ? colorClassNames[bgColor] : '';
	const buildingPatternSvg = require(`!raw-loader!../../../../assets/brochure-background/${bgColorClass}.svg`);
	const logoSvg = require(`!raw-loader!../../../../assets/${'logo-black'}.svg`);
	const moveInSvg = require('!raw-loader!../../../../assets/movein.svg');

	let className = 'b-page';

	if (classList) {
		className += ' ' + classList;
	}

	if (bgColorClass) {
		className += ' b-page-theme-' + bgColorClass;
	}

	if (options.layout !== 'default') {
		className += ' ' + options.layout;
	}

	if (options.logo) {
		className += ' has-logo';
	}

	if (options.moveIn) {
		className += ' has-move-in';
	}

	return (
		<StyledPage
			style={{ backgroundColor: options['background-color'] }}
			innerRef={props.innerRef}
			className={className}
		>
			{ options.buildingPattern &&
				<PatternContainer dangerouslySetInnerHTML={{__html: buildingPatternSvg }} />
			}

			{ options.logo &&
				<LogoContainer dangerouslySetInnerHTML={{__html: logoSvg }} />
			}
			{ options.moveIn &&
				<MoveInContainer dangerouslySetInnerHTML={{__html: moveInSvg }} />
			}
			{props.children}
		</StyledPage>
	)
}

Page.propTypes = {
	children: PropTypes.any,
	classList: PropTypes.string,
	innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
	options: PropTypes.shape({
		'background-color': PropTypes.string,
	}),
}

Page.defaultProps = {
	children: null,
	classList: '',
	options: {
		'background-color': 'white',
	}
}

export default Page;
